<template>
  <v-card-component :title="cardTitle" :icon="cardIcon">
    <div>
      <v-row>
        <v-col cols="12">
          <v-row>
            <v-col cols="12" lg="4" sm="6">
              <span class="body-2 font-weight-medium">Sibling Name</span>
              <v-text-field type="text" placeholder="Name of sibling" class="my-0 py-1" single-line
                v-model="value.siblingName" :readonly="isReadonly" :disabled="isDisabled">
              </v-text-field>
            </v-col>
            <v-col cols="12" lg="4" sm="6">
              <span class="body-2 font-weight-medium">Sibling Age</span>
              <v-text-field type="number" placeholder="Age" class="my-0 py-1" single-line
                v-model="value.siblingAge" :readonly="isReadonly" :disabled="isDisabled">
              </v-text-field>
            </v-col>
            <v-col cols="12" lg="4" sm="6">
              <span class="body-2 font-weight-medium">Sibling Class</span>
              <v-text-field type="text" placeholder="Class" class="my-0 py-1" single-line
                v-model="value.siblingClass" :readonly="isReadonly" :disabled="isDisabled">
              </v-text-field>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="4" sm="6">
          <span class="body-2 font-weight-medium">Sibling School</span>
          <v-autocomplete placeholder="School name" single-line class="my-0 py-1"
            v-model="value.siblingSchool" label="---Select---" :items="siblingSchool"
            item-text="siblingSchool" item-value="siblingSchool">
          </v-autocomplete>
        </v-col>
        <v-col cols="12" lg="4" sm="6" v-if="value.siblingSchool==='other'">
          <span class="body-2 font-weight-medium">please specify</span>
          <v-text-field type="text" placeholder="School name" class="my-0 py-1" single-line
            v-model="value.siblingOtherSchool" :readonly="isReadonly" :disabled="isDisabled">
          </v-text-field>
        </v-col>
      </v-row>
    </div>
    <div>
      <v-row>
        <v-col cols="12">
          <h1><span class="warning--text"><b>Refer your buddies to get a priority window to FirstCry
                Intellitots worlds of experiences</b></span></h1>
        </v-col>
        <v-col cols="12">
          <v-row>
            <v-col cols="12">
              <v-row>
                <v-col cols="12" lg="4" sm="6">
                  <span class="body-2 font-weight-medium">Child's name</span>
                  <v-text-field type="text" placeholder="Name" class="my-0 py-1" single-line
                    v-model="value.referralsChildName" :readonly="isReadonly"
                    :disabled="isDisabled"> </v-text-field>
                </v-col>
                <v-col cols="12" lg="4" sm="6">
                  <span class="body-2 font-weight-medium">Child's Age </span>
                  <v-text-field type="number" placeholder="Age" class="my-0 py-1" single-line
                    v-model="value.referralsChildAge" :readonly="isReadonly" :disabled="isDisabled">
                  </v-text-field>
                </v-col>
                <v-col cols="12" lg="4" sm="6">
                  <span class="body-2 font-weight-medium">Parent's / Mother's Name</span>
                  <v-text-field type="text" placeholder="Name" class="my-0 py-1" single-line
                    v-model="value.referralsFatherMotherName" :readonly="isReadonly"
                    :disabled="isDisabled"> </v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="4" sm="6">
          <span class="body-2 font-weight-medium">Parent's / Mother's Mobile No.</span>
          <v-text-field type="number" placeholder="Mobile No." class="my-0 py-1" single-line onKeyPress="if(this.value.length==10) return false;"
            v-model="value.referralsFatherMotherMobileNo" :readonly="isReadonly"
            :disabled="isDisabled"> </v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <span class="body-2 font-weight-medium">Relationship</span>
          <v-radio-group v-model="value.referralsRelation" row mandatory>
            <v-radio label="Friends" name="Relationship" value="Friends" class="mr-7">
            </v-radio>
            <v-radio label="Relatives" name="Relationship" value="Relatives" class="mr-7">
            </v-radio>
            <v-radio label="Acquintances" name="Relationship" value="Acquintances">
            </v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
    </div>
    </v-card-component>
</template>
<script>
import moment from 'moment'
import VCardComponent from '@/components/template/VCardComponent'
export default {
  name: 'SiblingElement',
  components: {
    VCardComponent
  },
  props: {
    formType: {
      default: '',
      type: String
    },
    value: {
      default: () => {},
      type: Object
    },
    isWritable: {
      default: 'false',
      type: String
    }
  },
  data: function () {
    return {
      isReadonly: false,
      isDisabled: false,
      cardTitle: '',
      cardIcon: '',
      siblingSchool: ['firstcry intellitots', 'other'],
      maxToDate: moment().format('YYYY-MM-DD')
    }
  },
  mounted () {
    if (this.isWritable === 'false') {
      this.isReadonly = true
      this.isDisabled = true
    }
  },

  created () {
    if (this.isWritable === 'false') {
      this.isReadonly = true
      this.isDisabled = true
    }
    this.cardTitle = 'Sibling Details'
    this.cardIcon = 'mdi-human-male-male'
  },
  methods: {}
}
</script>
